import { keyframes, styled } from '@metrika/ui-kit/emotion';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const NotificationWrapper = styled.div`
   text-align: center;
   width: 640px; /* Can be in percentage also. */
   height: auto;
   margin: 0 auto;
   padding: 10px;
   position: relative;

   animation: ${fadeIn} ease 1s;
`;
